import React, { useEffect, useState } from "react";
import { SanityLandingPageCarouselRow } from "../../model/landing-page";
import ArticleCard from "../ArticleCard/ArticleCard";
import GenericCard from "../GenericCard/GenericCard";
import { Wrapper } from "../Grid";
import { internalLinkUrl } from "../InternalLink/InternalLink";
import TeachRow from "../TeachRow/TeachRow";
import styles from "./LandingPageCarouselRow.module.scss";
import { fetchCachedBrowserInfo } from "../../utils/browser-info";
import { useConsent } from "../../utils/compliance";
import SupplimentaryContent from "./SupplimentaryContent/SupplimentaryContent";

const LandingPageCarouselRow = ({
  value
}: {
  value: SanityLandingPageCarouselRow;
}) => {
  const {
    type,
    title,
    subtitle,
    viewMoreText,
    internalLink,
    externalLink,
    skipRowText,
    items,
    content,
    countries
  } = value.carouselRow;
  const [showRow, setShowRow] = useState<boolean>(!countries?.length);
  const consent = useConsent();
  const viewAllURL = internalLink
    ? internalLinkUrl(
        internalLink.reference,
        internalLink.query,
        internalLink.fragment,
        undefined
      )
    : externalLink!;

  useEffect(() => {
    const showRowAsync = async () => {
      if (countries?.length) {
        const { country } = await fetchCachedBrowserInfo(consent);
        if (countries.some(c => c.code === country)) {
          setShowRow(true);
        }
      }
    };
    showRowAsync();
  }, [consent, countries]);

  if (type !== "manual" || !items || !showRow) {
    return null;
  }

  return (
    <Wrapper className={styles.root}>
      <TeachRow
        skipRowText={skipRowText}
        key={value._key}
        centerRow={value.centerRow}
        className={styles.noMargin}
        title={title}
        subtitle={subtitle}
        viewMoreText={viewMoreText}
        viewMoreURL={viewAllURL}
        cards={items.map(item =>
          item._type === "cardInternalLink" ? (
            <ArticleCard
              titleAs="h3"
              key={item.reference._id}
              article={item.reference}
              readMore={false}
              widths={400}
              textMaxLines={3}
            />
          ) : (
            <GenericCard
              titleAs="h3"
              key={item.title}
              layout="tile"
              card={item}
              widths={400}
              readMore={false}
              textMaxLines={3}
            />
          )
        )}
        content={!value.centerRow && content}
        contentComponent={
          value.centerRow && <SupplimentaryContent content={content} />
        }
      />
    </Wrapper>
  );
};

export default LandingPageCarouselRow;
